// @flow
import React, { useState, useRef } from 'react';
import {
  Modal, Radio, Input,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import { SpH5, SpButton, SpError } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  subscriptionDetails: Object,
};

const AddDiscount = (props: Props) => {
  const {
    visible,
    close,
    submit,
    subscriptionDetails,
  } = props;

  const [, forceUpdate] = useState();
  const [feesType, setFeesType] = useState('PERCENTAGE');
  const [overdueFee, setOverdueFee] = useState(null);
  const { prefix } = subscriptionDetails?.currency;
  const [count, setCount] = useState(null);

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      frequency: {
        message: 'Billing period should not be more than 365 days',
        // eslint-disable-next-line radix
        rule: (val) => parseInt(val) <= 365,
      },
    },
  }));

  const onFeesChange = (e) => {
    setFeesType(e.target.value);
  };

  // eslint-disable-next-line consistent-return
  const deleteSelectedSubscription = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return false;
    }
    const payload = {
      feesType,
      overdueFee,
      count,
    };
    submit(payload);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      title="Add Discount"
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedSubscription} type="primary">Save</SpButton>,
      ]}
    >
      <div className="px-4">
        <div className="mb-3 d-flex align-items-center">
          <div style={{ width: '50%' }} className="mr-3">
            <label htmlFor=""><SpH5>Discount</SpH5></label>
            <div>
              <Input
                maxlength="3"
                suffix={feesType === 'PERCENTAGE' ? '%' : prefix}
                value={overdueFee}
                onChange={(e) => {
                  const regex = /^[0-9\b]+$/;
                  const { value } = e.currentTarget;
                  if (regex.test(value) || value === '') {
                    setOverdueFee(e.currentTarget.value);
                  } else if (!regex.test(value)) {
                    setOverdueFee();
                  }
                }}
                onKeyPress={e => {
                  const keyCode = e.charCode || e.which;
                  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div>
              <SpError>
                {simpleValidator.current.message('Pause type', overdueFee, 'required')}
              </SpError>
            </div>
          </div>
          <div style={{ width: '50%' }} className="ml-3">
            <label htmlFor=""><SpH5>&nbsp;</SpH5></label>
            <div>
              <Radio.Group onChange={onFeesChange} value={feesType}>
                <Radio value="PERCENTAGE">Percentage</Radio>
                <Radio value="AMOUNT">Flat Amount</Radio>
              </Radio.Group>
            </div>
          </div>
        </div>

        <div className="mt-3" style={{ width: '50%' }}>
          <label htmlFor=""><SpH5>Total Count (Optional)</SpH5></label>
          <Input
            placeholder="No. of billing cycles to be charged"
            value={count}
            onChange={(e) => {
              const regex = /^[0-9\b]+$/;
              const { value } = e.currentTarget;
              if (regex.test(value) || value === '') {
                setCount(e.currentTarget.value);
              } else if (!regex.test(value)) {
                setCount(null);
              }
            }}
            onKeyPress={e => {
              const keyCode = e.charCode || e.which;
              if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                e.preventDefault();
              }
            }}
          />
        </div>
        <div>
          <SpError>
            {simpleValidator.current.message('Total Count', count, 'required')}
          </SpError>
        </div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default AddDiscount;
